import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faShoppingCart, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import whatsappIcon from '../../images/wpp.png';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todo');
    const [cantidades, setCantidades] = useState({});
    const [contactos, setContactos] = useState([]);

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    // Inicializar cantidades para cada producto
    useEffect(() => {
        const initialCantidades = {};
        productos.forEach(producto => {
            initialCantidades[producto.idProducto] = 1;
        });
        setCantidades(initialCantidades);
    }, [productos]);

    // Cargar contactos para WhatsApp
    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    // Función para incrementar cantidad
    const incrementCantidad = (idProducto) => {
        setCantidades(prev => ({
            ...prev,
            [idProducto]: prev[idProducto] + 1
        }));
    };

    // Función para decrementar cantidad
    const decrementCantidad = (idProducto) => {
        setCantidades(prev => ({
            ...prev,
            [idProducto]: prev[idProducto] > 1 ? prev[idProducto] - 1 : 1
        }));
    };

    // Función para agregar al carrito
    const addToCart = (producto) => {
        if (producto.stock < 1) {
            toast.error('No hay stock', { autoClose: 400 });
            return;
        }
        
        const cantidad = cantidades[producto.idProducto] || 1;
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const existingItemIndex = cart.findIndex(item =>
            item.idProducto === producto.idProducto
        );
        
        if (existingItemIndex !== -1) {
            const existingItem = cart[existingItemIndex];
            const updatedCantidad = existingItem.cantidad + cantidad;
            cart[existingItemIndex] = { ...existingItem, cantidad: updatedCantidad };
        } else {
            cart.push({ idProducto: producto.idProducto, cantidad });
            toast.success(`${producto.titulo} agregado al carrito`, { autoClose: 400 });
        }
        
        // Guardar en localStorage
        localStorage.setItem('cart', JSON.stringify(cart));
        
        // Disparar evento para actualizar el carrito
        window.dispatchEvent(new Event('cartUpdated'));
    };

    // Función para WhatsApp
    const handleWhatsappMessage = (producto) => {
        const phoneNumber = contactos?.telefono;
        const formattedPrice = Number(producto?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${producto.titulo}*\n     ${producto.descripcion}\n     ${moneda} ${formattedPrice}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };


    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) {
            return item.imagen1;
        } else if (item.imagen2) {
            return item.imagen2;
        } else if (item.imagen3) {
            return item.imagen3;
        } else if (item.imagen4) {
            return item.imagen4;
        }
        return null;
    };

    const categoriasConProductos = categorias.filter(categoria =>
        productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    return (
        <div className='ProductsContain'>
            <ToastContainer />
            {productos?.length > 0 && (
                <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} ref={categoriasInputRef}>
                    <input
                        type="button"
                        value="Todo"
                        onClick={() => handleClickCategoria('Todo')}
                        style={{
                            backgroundColor: categoriaSeleccionada === 'Todo' ? '#0c71cf' : '',
                            color: categoriaSeleccionada === 'Todo' ? '#fff' : '',
                            borderBottom: categoriaSeleccionada === 'Todo' ? '2px solid #0c71cf' : 'none'
                        }}
                    />
                    {categoriasConProductos.map(({ categoria, idCategoria }) => (
                        <input
                            key={idCategoria}
                            type="button"
                            value={categoria}
                            onClick={() => handleClickCategoria(idCategoria)}
                            style={{
                                backgroundColor: categoriaSeleccionada === idCategoria ? '#0c71cf' : '',
                                color: categoriaSeleccionada === idCategoria ? '#fff' : '',
                                borderBottom: categoriaSeleccionada === idCategoria ? '2px solid #0c71cf' : 'none'
                            }}
                        />
                    ))}
                </div>
            )}


            {loading ? (
                <ProductosLoading />
            ) : (
                <div className='Products'>
                    {categoriaSeleccionada === 'Todo' && (
                        <>
                            {productos?.some(item => item.masVendido === "si") && (
                                <div className='categoriSection'>
                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products'
                                        autoplay={{ delay: 3000 }}
                                    >
                                        {productos?.filter(item => item.masVendido === "si").map(item => (
                                            <SwiperSlide key={item.idProducto} id='SwiperSlide-scroll-products-masvendidos'>
                                                <div className='cardProdcutmasVendido'>
                                                    <Anchor to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <h6 className='masVendido'>Más Vendido</h6>
                                                        <div className='cardText'>
                                                            <h4 title={item.titulo}>{item.titulo}</h4>
                                                            <span>{item.descripcion}</span>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Anchor>
                                                    <div className='cardActions'>
                                                        <div className='deFlexCart'>
                                                            <button onClick={() => decrementCantidad(item.idProducto)} className='btnCantidad'>
                                                                <FontAwesomeIcon icon={faMinus} />
                                                            </button>
                                                            <span>{cantidades[item.idProducto] || 1}</span>
                                                            <button onClick={() => incrementCantidad(item.idProducto)} className='btnCantidad'>
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </button>
                                                        </div>
                                                        <div className='deFlexGoTocart'>
                                                            <button onClick={() => addToCart(item)} className='btnAdd'>
                                                                <FontAwesomeIcon icon={faShoppingCart} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )}

                            {categoriasConProductos?.map(({ categoria, idCategoria }) => (
                                <div key={idCategoria} className='categoriSection' ref={ref => categoriasRefs.current[categorias.findIndex(cat => cat.idCategoria === idCategoria)] = ref}>
                                    <div className='deFlexTitlesection'>
                                        <h3>{categoria}</h3>
                                        <button onClick={() => handleClickCategoria(idCategoria)}>
                                            Ver más
                                        </button>
                                    </div>

                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products'
                                    >


                                        {productos?.filter(item => item.idCategoria === idCategoria).map(item => (
                                            <SwiperSlide id='SwiperSlide-scroll-products' key={item.idProducto}>
                                                <div className='cardProdcut'>
                                                    <Anchor to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                                        <img src={obtenerImagen(item)} alt="imagen" />
                                                        <div className='cardText'>
                                                            <h4 title={item.titulo}>{item.titulo}</h4>
                                                            <span>{item.descripcion}</span>
                                                            <div className='deFLexPrice'>
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                                )}
                                                            </div>
                                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                                        </div>
                                                    </Anchor>
                                                    <div className='cardActions'>
                                                        <div className='deFlexCart'>
                                                            <button onClick={() => decrementCantidad(item.idProducto)} className='btnCantidad'>
                                                                <FontAwesomeIcon icon={faMinus} />
                                                            </button>
                                                            <span>{cantidades[item.idProducto] || 1}</span>
                                                            <button onClick={() => incrementCantidad(item.idProducto)} className='btnCantidad'>
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </button>
                                                        </div>
                                                        <div className='deFlexGoTocart'>
                                                            <button onClick={() => addToCart(item)} className='btnAdd'>
                                                                <FontAwesomeIcon icon={faShoppingCart} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}

                                    </Swiper>
                                </div>

                            ))}
                        </>
                    )}

                    <div className='categoriSectionSelected'>
                        {productos
                            ?.filter(item => categoriaSeleccionada !== 'Todo' && item.idCategoria === categoriaSeleccionada)
                            ?.map(item => (
                                <div key={item.idProducto} className='cardProdcutSelected'>
                                    <Anchor to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                        <img src={obtenerImagen(item)} alt="imagen" />
                                        <div className='cardTextSelected'>
                                            <h4 title={item.titulo}>{item.titulo}</h4>
                                            <span>{item.descripcion}</span>
                                            <div className='deFLexPrice'>
                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                )}
                                            </div>
                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                        </div>
                                    </Anchor>
                                    <div className='cardActions'>
                                        <div className='deFlexCart'>
                                            <button onClick={() => decrementCantidad(item.idProducto)} className='btnCantidad'>
                                                <FontAwesomeIcon icon={faMinus} />
                                            </button>
                                            <span>{cantidades[item.idProducto] || 1}</span>
                                            <button onClick={() => incrementCantidad(item.idProducto)} className='btnCantidad'>
                                                <FontAwesomeIcon icon={faPlus} />
                                            </button>
                                        </div>
                                        <div className='deFlexGoTocart'>
                                            <button onClick={() => addToCart(item)} className='btnAdd'>
                                                <FontAwesomeIcon icon={faShoppingCart} />
                                            </button>
                                            <button className="wpp" onClick={() => handleWhatsappMessage(item)}>
                                                <img src={whatsappIcon} alt="whatsappIcon" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </div>
    );
}
